module.exports = __webpack_public_path__ + "img/12.173dcb29.png";